import { useEffect, useState } from "react";
const API = "/api";
const token = () => localStorage.getItem("token");

export default function Pedidos() {
  const [pedidos, setPedidos] = useState<any[]>([]);
  const [clientes, setClientes] = useState<any[]>([]);
  const [vendedores, setVendedores] = useState<any[]>([]);
  const [facturandoId, setFacturandoId] = useState<number | null>(null);
  const [tipoFactura, setTipoFactura] = useState<"contado" | "credito">("contado");
  const [clienteId, setClienteId] = useState("");
  const [vendedorId, setVendedorId] = useState("");
  const [metodoPago, setMetodoPago] = useState("efectivo");
  const [abonoInicial, setAbonoInicial] = useState("");
  const [enviando, setEnviando] = useState(false);

  const cargar = () => {
    fetch(`${API}/pedidos/`,{headers:{Authorization:`Bearer ${token()}`}})
      .then(r=>r.json()).then(d=>Array.isArray(d)&&setPedidos(d)).catch(()=>{});
  };
  useEffect(()=>{
    cargar();
    fetch(`${API}/creditos/clientes?activo=true`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setClientes(d)).catch(() => {});
    fetch(`${API}/contado/vendedores?activo=true`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setVendedores(d)).catch(() => {});
  },[]);

  const cambiarEstado = async (id:number, estado:string) => {
    await fetch(`${API}/pedidos/${id}/estado`,{method:"PUT",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token()}`},body:JSON.stringify({estado})});
    cargar();
  };

  const abrirFacturar = (id: number) => {
    setFacturandoId(id);
    setTipoFactura("contado");
    setClienteId(""); setVendedorId(""); setMetodoPago("efectivo"); setAbonoInicial("");
  };

  const confirmarFacturar = async () => {
    if (!facturandoId) return;
    if (tipoFactura === "credito" && !clienteId) {
      alert("Para facturar a crédito debés elegir un cliente registrado");
      return;
    }
    setEnviando(true);
    const body: any = {
      tipo: tipoFactura,
      cliente_id: clienteId ? Number(clienteId) : null,
      vendedor_id: vendedorId ? Number(vendedorId) : null,
    };
    if (tipoFactura === "contado") body.metodo_pago = metodoPago;
    if (tipoFactura === "credito") {
      body.abono_inicial = abonoInicial ? Number(abonoInicial) : null;
      body.metodo_pago_inicial = metodoPago;
    }
    const r = await fetch(`${API}/facturacion/pedidos/${facturandoId}/facturar`, {
      method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify(body),
    });
    const data = await r.json();
    setEnviando(false);
    if (r.ok) {
      setFacturandoId(null);
      cargar();
    } else {
      alert("Error: " + (data.detail || "no se pudo facturar"));
    }
  };

  const colores:any = {pendiente:"#f59e0b",confirmado:"#3b82f6",enviado:"#8b5cf6",entregado:"#22c55e",cancelado:"#ef4444"};
  const input = { width: "100%", padding: "8px 10px", borderRadius: "8px", border: "1.5px solid #e5e7eb", fontSize: "13px", fontFamily: "Nunito,sans-serif", boxSizing: "border-box" as const };
  const label = { display: "block", fontSize: "11px", fontWeight: 700, color: "#6b7280", marginBottom: "4px" };

  return (
    <div>
      <h1 style={{fontFamily:"Montserrat,sans-serif",fontSize:"24px",fontWeight:900,marginBottom:"24px",color:"#1a1a2e"}}>Pedidos ({pedidos.length})</h1>
      <div style={{display:"flex",flexDirection:"column",gap:"12px"}}>
        {pedidos.map(p => (
          <div key={p.id} style={{background:"#fff",borderRadius:"16px",padding:"20px",boxShadow:"0 2px 8px rgba(0,0,0,0.06)",borderLeft:`4px solid ${colores[p.estado]||"#ccc"}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:"12px"}}>
              <div>
                <div style={{fontWeight:800,fontSize:"16px",marginBottom:"4px"}}>
                  #{p.id} — {p.nombre_cliente}
                  {p.facturado && <span style={{marginLeft:"8px",fontSize:"11px",background:"#ECFDF5",color:"#065F46",padding:"2px 8px",borderRadius:"6px",fontWeight:700}}>✓ Facturado</span>}
                </div>
                <div style={{fontSize:"13px",color:"#6b7280"}}>📞 {p.telefono} {p.direccion&&`| 📍 ${p.direccion}`}</div>
                <div style={{fontSize:"13px",color:"#6b7280",marginTop:"4px"}}>{new Date(p.creado_en).toLocaleString()}</div>
                {p.items && (
                  <div style={{marginTop:"8px",fontSize:"13px"}}>
                    {(typeof p.items === "string" ? JSON.parse(p.items) : p.items).map((i:any,idx:number) => (
                      <span key={idx} style={{background:"#EFF6FF",color:"#1565C0",padding:"2px 8px",borderRadius:"6px",marginRight:"4px",fontWeight:600}}>
                        {i.nombre} x{i.cantidad}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontFamily:"Montserrat,sans-serif",fontSize:"20px",fontWeight:900,color:"#1565C0",marginBottom:"8px"}}>
                  ₡{p.total?.toLocaleString()}
                </div>
                <select value={p.estado} onChange={e=>cambiarEstado(p.id,e.target.value)}
                  style={{border:`2px solid ${colores[p.estado]||"#ccc"}`,borderRadius:"8px",padding:"6px 12px",fontWeight:700,fontSize:"13px",color:colores[p.estado],background:"#fff",cursor:"pointer",fontFamily:"Nunito,sans-serif",marginBottom:"8px"}}>
                  {["pendiente","confirmado","enviado","entregado","cancelado"].map(s=>(
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
                <div>
                  {!p.facturado && (
                    <button onClick={() => abrirFacturar(p.id)}
                      style={{ display: "block", width: "100%", background: "#0D47A1", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 14px", fontWeight: 700, fontSize: "13px", cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                      🧾 Facturar
                    </button>
                  )}
                </div>
              </div>
            </div>

            {facturandoId === p.id && (
              <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px dashed #e5e7eb", background: "#F9FAFB", borderRadius: "12px", padding: "16px" }}>
                <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
                  <button onClick={() => setTipoFactura("contado")}
                    style={{ flex: 1, background: tipoFactura === "contado" ? "#22c55e" : "#fff", color: tipoFactura === "contado" ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "8px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}>
                    💵 Contado
                  </button>
                  <button onClick={() => setTipoFactura("credito")}
                    style={{ flex: 1, background: tipoFactura === "credito" ? "#0D47A1" : "#fff", color: tipoFactura === "credito" ? "#fff" : "#374151", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "8px", fontWeight: 700, fontSize: "13px", cursor: "pointer" }}>
                    💳 Crédito
                  </button>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "10px" }}>
                  <div>
                    <label style={label}>Cliente {tipoFactura === "credito" ? "* (requerido)" : "(opcional)"}</label>
                    <select style={input} value={clienteId} onChange={e => setClienteId(e.target.value)}>
                      <option value="">{tipoFactura === "credito" ? "-- Elegir --" : `-- Usar "${p.nombre_cliente}" --`}</option>
                      {clientes.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={label}>Vendedor (opcional)</label>
                    <select style={input} value={vendedorId} onChange={e => setVendedorId(e.target.value)}>
                      <option value="">-- Sin asignar --</option>
                      {vendedores.map(v => <option key={v.id} value={v.id}>{v.nombre}</option>)}
                    </select>
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "12px" }}>
                  <div>
                    <label style={label}>{tipoFactura === "credito" ? "Método (si hay enganche)" : "Método de pago"}</label>
                    <select style={input} value={metodoPago} onChange={e => setMetodoPago(e.target.value)}>
                      <option value="efectivo">Efectivo</option>
                      <option value="sinpe">Sinpe Móvil</option>
                      <option value="transferencia">Transferencia</option>
                      <option value="tarjeta">Tarjeta</option>
                    </select>
                  </div>
                  {tipoFactura === "credito" && (
                    <div>
                      <label style={label}>Enganche (opcional)</label>
                      <input type="number" style={input} value={abonoInicial} onChange={e => setAbonoInicial(e.target.value)} />
                    </div>
                  )}
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <button onClick={confirmarFacturar} disabled={enviando}
                    style={{ flex: 1, background: "#0D47A1", color: "#fff", border: "none", borderRadius: "8px", padding: "10px", fontWeight: 800, cursor: "pointer", fontFamily: "Nunito,sans-serif" }}>
                    {enviando ? "Procesando..." : `Confirmar factura por ₡${p.total?.toLocaleString()}`}
                  </button>
                  <button onClick={() => setFacturandoId(null)}
                    style={{ background: "#fff", color: "#6b7280", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "10px 16px", fontWeight: 700, cursor: "pointer" }}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
        {pedidos.length===0&&<div style={{textAlign:"center",padding:"60px",color:"#9ca3af",background:"#fff",borderRadius:"16px"}}>No hay pedidos aun</div>}
      </div>
    </div>
  );
}
